import { useState } from "react";

const useCopy = () => {
  const [isCopying, setIsCopying] = useState(false);

  const copy = async (text: string) => {
    try {
      setIsCopying(true);
      await navigator.clipboard.writeText(text);
      setTimeout(() => {
        setIsCopying(false);
      }, 2000);
    } catch {
      setIsCopying(false);
    }
  };

  return {
    isCopying,
    copy,
  };
};

export default useCopy;
